import { SprintState } from '@/types/sprint';
import { Sprint, SprintSettings } from '@superthread-com/api';
import { getCurrentInstance, computed } from 'vue';

export default function useSpaceHomeSprints() {
  const _this = getCurrentInstance()?.proxy as any;

  const spaceSprints = computed((): Sprint[] => {
    return (
      (Object.values(_this.$store.getters.getSpaceSprints(_this.currentProjectId)).sort(
        (a: any, b: any) => b.orginalId - a.orginalId
      ) as Sprint[]) || []
    );
  });

  const sprintIds = computed(() => {
    const activeSprint: Sprint[] =
      spaceSprints.value.filter((sprint: Sprint) => sprint.state === SprintState.Active) || [];
    const plannedSprint: Sprint[] =
      spaceSprints.value.filter((sprint: Sprint) => sprint.state === SprintState.Planned) || [];

    const sprintIds: string[] = [];

    if (plannedSprint.length > 0) {
      const plannedSprintId = plannedSprint[plannedSprint.length - 1]?.id;
      if (plannedSprintId) {
        sprintIds.push(plannedSprintId);
      }
    }
    if (activeSprint.length > 0) {
      const activeSprintId = activeSprint[0]?.id;
      if (activeSprintId) {
        sprintIds.push(activeSprintId);
      }
    }

    return sprintIds;
  });

  const sprintSettings = computed((): SprintSettings => {
    return _this.$store.getters.getSprintSettings(_this.currentProjectId) || {};
  });

  const sprintsCoolDownPeriod = computed((): number => {
    return sprintSettings.value?.cooldown ?? 0;
  });

  const spaceSprintsEnabled = computed((): boolean => {
    return sprintSettings.value?.enabled ?? false;
  });

  return {
    spaceSprints,
    sprintIds,
    sprintsCoolDownPeriod,
    spaceSprintsEnabled,
  };
}
